<template>
  <div
    v-if='image'
    class='picture wrapper'>
    <template v-if='readytoload || image.loaded==true'>
      <transition
        :name='pop(image)'
        appear>
        <picture>
          <img
            :v-show='image.loaded'
            v-once
            v-bind='srcset(image, sizes)'
            @load='finishedLoading()'
            :alt='image.name'>
        </picture>
      </transition>
    </template>
  </div>
</template>

<script>
module.exports = {
  props: ['image', 'sizes'],
  data: function() {
    return  {
      readytoload: false,
      addedtoqueue: false,
      offset: 700,
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
    this.$root.$on('loadIfNext', this.loadIfNext);
  },
  mounted() {
    this.updateImage();
  },
  updated() {
    this.updateImage();
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    inWindow: function() {
      return ((this.$el.getBoundingClientRect().top) < (window.scrollY + window.innerHeight + this.offset));
    },
    finishedLoading: function() {
      this.image.loaded = true;
      this.$root.nextInQueue();
    },
    loadIfNext: function(){
      if(this.$root.queue.items[this.$root.queue.current] == this.image.name){
        this.readytoload = true
      }
    },
    updateImage: function () {
      if(!this.image.loaded) {
        setTimeout( this.sendToQueueIfInWindow(), 5);
      }
    },
    handleScroll: function () {
      this.sendToQueueIfInWindow();
    },
    sendToQueueIfInWindow: function() {
      if(this.inWindow() && !this.image.loaded && !this.addedtoqueue){
        this.$root.addToQueue(this.image.name);
        this.addedtoqueue = true;
      }
    },
    pop: function(){
      if(this.image.loaded){
        return 'none'
      } else {
        return 'pop';
      }
    },
    srcset: function(image, sizes){
      if(this.image.thumbnails){
        var srcarray = [];
        Object.keys(this.image.thumbnails).forEach((id) => {
          srcarray.push( this.image.thumbnails[id] + ' ' + id.replace('w','')+'w');
        });
        return {
          srcset: srcarray.join(', '),
          sizes: this.sizes
        }
      }
    }
  }

}
</script>

<style>
  .picture.wrapper {
    position: relative;
  }

  .picture.wrapper picture {
    height: 100%;
    width: 100%;
    position: absolute;
    text-align: center;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    object-fit: cover;
  }

  .picture.wrapper picture img {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: -100%;
    bottom: -100%;
    margin: auto;
  }

  .blur.wrapper {
    display: block;
    overflow: hidden;
    max-height: 100%;
    opacity: 0.2;
  }

  .picture.wrapper .placeholder img {
    vertical-align: bottom;
  }

  /* Animation */
  .pop-enter-active, .pop-leave-active {
    transition-duration: 1s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .pop-enter, .pop-leave-active {
    opacity: 0
  }
</style>
